import { useState, useEffect } from 'react';
import { get } from '../utils/api';
import { LearnStockDailyResponse } from '../types/learnStocksDaily';

export function useLearnStocksDaily() {
  const [data, setData] = useState<LearnStockDailyResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      try {
        const res = await get<LearnStockDailyResponse>('/api/learn-stocks-daily/today');
        if (!cancelled && res.data) {
          setData(res.data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load daily stock');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchData();
    return () => { cancelled = true; };
  }, []);

  return { data, loading, error };
}
